import styled from "styled-components";

export const CustomButton = styled.button`
  width: ${props => props.$width || "100%"};
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  border: none;
  height: ${props => props.$height || "35px"} ;
  border-radius: ${props => props.$borderRadius || '8px'};
  font-size: ${props => props.$fontSize || 'var(--font-size-button)'};
  padding: 0.375rem 0.75rem;
  cursor: pointer;
  transition: ease-in all 0.1s;
  color: ${props => props.$color || "#334155"}!important;
  background-color: ${props => props.$disabled ? '#c1c1c1' : props.$backgroundColor || "white"}!important;
  position: relative;
  font-family: 'Poppins', sans-serif;
  position: relative;

  @keyframes rotating {
    from{
        transform: rotate(0deg);
    }
    to{
        transform: rotate(360deg);
    }
  }

  .spinner {
    animation: rotating 1.3s linear infinite;
  }

  ${props => props.$fontWeight && `
    font-weight: ${props.$fontWeight};
  `}

  ${props => props.$border && `
    border: ${props.$border}!important;
  `}

  ${props => props.$isLoginButton &&
    `
      height: 50px;
      font-size: 20px;
      
      @media screen and (max-width: 1366px){
        & {
            height: 40px;
            font-size: 15px;
        }
      }
    `
  }

  ${props => props.$disabled ?
    `
      pointer-events: none;
    `
    :
    `
      &:hover {
        background-color: ${props.$hoverColor || "#f5f5f5"}!important;
        transition: ease-in all 0.1s;
      }
    `
  }

  ${props => props.$containsIcon && `
    line-height: 1.3;
  `
  }

  ${props => props.$isShadow && `
    box-shadow: 0 0 2px 1px #dae2f0;
  `}
`
